import React from 'react';

import { useVehicles } from '@/hooks/used-cars/vehicles.hook';

import styles from './mobile-results.module.scss';

export const MobileResults: React.FC = () => {
  const { vehiclesMeta } = useVehicles();

  return (
    <div className={styles.mobileResults}>
      <p data-cy="used-cars-results-count">
        Results {vehiclesMeta.filterCount} cars
      </p>
    </div>
  );
};
